import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.css'
import MainController from './controller'

ReactDOM.render(<MainController />, document.getElementById('root'));